// Actions
export const SET_GLOBAL_RECORD = 'SET_GLOBAL_RECORD';
export const SET_GLOBAL_REFRESH = 'SET_GLOBAL_REFRESH';
export const SET_GLOBAL_CALLED = 'SET_GLOBAL_CALLED';

export const SET_GLOBAL_USERS = 'SET_GLOBAL_USERS';
export const FETCH_GLOBAL_USERS = 'FETCH_GLOBAL_USER';
export const SET_GLOBAL_USER_REFRESH = 'SET_GLOBAL_USER_REFRESH';
export const SET_GLOBAL_USER_CALLED = 'SET_GLOBAL_USER_CALLED';
export const FETCH_GLOBAL_SITES = 'FETCH_GLOBAL_SITES';
export const FETCH_GLOBAL_LIST = 'FETCH_GLOBAL_LIST';

const initialState = {
  users: {
    record: {},
    refresh: false,
    hasBeenCalled: false,
  },
  sites: {
    record: {},
    refresh: false,
    hasBeenCalled: false,
  },
  businessClients: {
    record: {},
    refresh: false,
    hasBeenCalled: false,
  },
  departments: {
    record: {},
    refresh: false,
    hasBeenCalled: false,
  },
};
// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_GLOBAL_RECORD:
      return {
        ...state,
        [action.category]: { ...state[action.category], record: action.record },
      };
    case SET_GLOBAL_REFRESH:
      return {
        ...state,
        [action.category]: {
          ...state[action.category],
          refresh: action.refresh,
        },
      };
    case SET_GLOBAL_CALLED:
      return {
        ...state,
        [action.category]: {
          ...state[action.category],
          hasBeenCalled: action.called,
        },
      };
    // do reducer stuff
    default:
      return state;
  }
}

// Action Creators
export function setGlobalUserRecord({ record, category }) {
  return { type: SET_GLOBAL_RECORD, record, category };
}
export function setGlobalCalled({ called, category }) {
  return { type: SET_GLOBAL_CALLED, called, category };
}
export function setGlobalRefresh({ refresh, category }) {
  return { type: SET_GLOBAL_REFRESH, refresh, category };
}
export function fetchGlobalUsers() {
  return { type: FETCH_GLOBAL_USERS };
}
export function fetchGlobalSites() {
  return { type: FETCH_GLOBAL_LIST };
}
export function fetchGlobalBusinessClients() {
  return { type: FETCH_GLOBAL_USERS };
}
export function setGlobalRecord({ record, category }) {
  return { type: SET_GLOBAL_RECORD, record, category };
}
export function fetchGlobalList({ category }) {
  return { type: FETCH_GLOBAL_LIST, category };
}
// Selectors
export const getGlobalUsersRecord = state => state.globalList.users.record;
export const getGlobalSiteRecord = state => state.globalList.users.record;
export const getGlobalBusinessClientRecord = state =>
  state.globalList.businessClients.record;
export const getGlobalUsersCalled = state =>
  state.globalList.users.hasBeenCalled;
export const getGlobalUsersRefresh = state => state.globalList.users.refresh;

export const getGlobalCalled = (state, category) =>
  state.globalList[category].hasBeenCalled;
export const getGlobalRefresh = (state, category) =>
  state.globalList[category].refresh;
export const getGlobalRecord = (state, category) =>
  state.globalList[category].record;
